import {Injectable} from "@angular/core";

import {Subject} from "rxjs";

// keep synced with app.variables.scss
export const LAYOUT_WIDTH_SM: number = 600;
export const LAYOUT_WIDTH_MD: number = 960;
export const LAYOUT_WIDTH_LG: number = 1280;

@Injectable({providedIn: "root"})
export class CommonLayout
{
    contentSizeChanged = new Subject<void>();
}

export const TABLE_CELL_BORDER_SPACING: number = 1;
